module.exports = __webpack_public_path__ + "media/images/members/antonio_azaustre_galiana-0b5fe42eaa27a8fd6bc7d78919117b41.jpg";